// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_CriarSubcontaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /payments/accounts/criar_subconta
 *
 * Returns {account, provider_response}:
 *   - account: the newly-created sanitized subaccount object
 *     (subaccounts_model->getById() run through sanitizeForFrontend()), the
 *     identical shape the sibling atualizar/atualizar_config endpoints return,
 *     typed via SubaccountsFranchises_AtualizarConfigRow.
 *   - provider_response: a two-key passthrough of the upstream provider's
 *     createSubaccount() result ({id, status}).
 *
 * @see controllers/subaccounts/franchises.php::criar_subconta()
 */
import type { SubaccountsFranchises_CriarSubcontaDadosRow } from './SubaccountsFranchises_CriarSubcontaDadosRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type SubaccountsFranchises_CriarSubcontaResponseDados = SubaccountsFranchises_CriarSubcontaDadosRow;

export type SubaccountsFranchises_CriarSubcontaResponse = ApiResponse<SubaccountsFranchises_CriarSubcontaResponseDados>;

registerResponseContract('SubaccountsFranchises_CriarSubcontaResponse', {
  account: {
    type: 'object',
    required: true,
    fields: {
      id:                  { type: 'number',  required: true },
      provider_id:         { type: 'number',  required: true },
      provider_account_id: { type: 'string',  required: false },
      wallet_id:           { type: 'string',  required: false },
      api_key:             { type: 'string',  required: false },
      name:                { type: 'string',  required: true },
      email:               { type: 'string',  required: false },
      document:            { type: 'string',  required: false },
      document_type:       { type: 'string',  required: false },
      phone:               { type: 'string',  required: false },
      address:             { type: 'object',  required: false },
      bank_account:        { type: 'object',  required: false },
      status:              { type: 'string',  required: true },
      config:              { type: 'object',  required: false },
      fiscal_config:       { type: 'object',  required: false },
      sandbox_mode:        { type: 'number',  required: true },
      webhook_token:       { type: 'string',  required: false },
      last_sync_at:        { type: 'string',  required: false },
      created_at:          { type: 'string',  required: true },
      updated_at:          { type: 'string',  required: true },
      anticipation_config: { type: 'object',  required: false },
      provider_code:       { type: 'string',  required: true },
      provider_name:       { type: 'string',  required: true },
      api_base_url:        { type: 'string',  required: true },
      sandbox_api_url:     { type: 'string',  required: true },
      franchises: {
        type: 'array',
        required: false,
        items: {
          id:           { type: 'number',  required: true },
          franchise_id: { type: 'number',  required: true },
          created_at:   { type: 'string',  required: false },
          franquia:     { type: 'string',  required: false },
        },
      },
    },
  },
  provider_response: {
    type: 'object',
    required: true,
    fields: {
      id:     { type: 'string',  required: true },
      status: { type: 'string',  required: false },
    },
  },
})
